import { BasilArrowLeft, BasilHourglass } from "@/components/icons/basil";
import { GlassPanel } from "@/components/ui/GlassPanel";
import { GlowButton } from "@/components/ui/GlowButton";

type ComingSoonPageProps = {
  title: string;
};

/** Placeholder page for official-service routes that are not shipped yet. */
export function ComingSoonPage({ title }: ComingSoonPageProps) {
  return (
    <div className="flex flex-1 items-center justify-center py-10">
      <GlassPanel
        className="w-full max-w-xl px-6 py-14 text-center sm:px-10 sm:py-20"
        aria-label={`${title} coming soon`}
      >
        <div className="flex flex-col items-center gap-5">
          <span className="grid size-14 place-items-center rounded-lg border border-line bg-white/4">
            <BasilHourglass className="size-6 text-accent" aria-hidden />
          </span>

          <div>
            <p className="ty-eyebrow">TycoonEX</p>
            <h1 className="mt-2 font-display text-2xl font-medium text-ink sm:text-3xl">
              {title} <span className="text-accent">coming soon</span>
            </h1>
            <p className="mx-auto mt-3 max-w-sm text-xs leading-relaxed text-ink-mute sm:text-sm">
              New packs, cards and rewards are on the way.
            </p>
          </div>

          <GlowButton to="/home">
            <BasilArrowLeft className="size-4" aria-hidden />
            Back to Home
          </GlowButton>
        </div>
      </GlassPanel>
    </div>
  );
}
